import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

// Simple SVG icons
const PlayCircleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);

const Hero: React.FC = () => {
  return (
    <section className="hero-section">
      <div className="hero-container centered">
        <motion.div 
          className="hero-content centered"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="hero-title pencil-text text-center">
            Изучайте языки через <span className="text-primary">фильмы</span> и <span className="text-primary">сериалы</span>
          </h1>
          <p className="hero-description pencil-text text-center">
            LinguaSub создает персонализированные словари из субтитров, помогая вам учить слова в контексте вашего любимого контента.
          </p>
          <div className="hero-buttons centered">
            <Link to="/signin">
              <motion.button 
                className="primary-button pencil-outline"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Начать бесплатно
              </motion.button>
            </Link>
            <motion.button 
              className="secondary-button pencil-outline"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
            </motion.button>
          </div>
        </motion.div>
        
        <motion.div 
          className="hero-image centered"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <div className="hero-image-inner pencil-outline">
            <div className="dictionary-example">
              <h3 className="dictionary-title pencil-text">Персонализированный словарь</h3>
              <div className="dictionary-card pencil-outline">
                <div className="word">гравитационный</div>
                <div className="definition">относящийся к гравитации или притяжению</div>
                <div className="context">"<span className="text-primary">Гравитационная</span> аномалия все меняет."</div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero; 